import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EntityList } from 'app/models/entity-list.model';
import { map, Observable, Subject, tap } from 'rxjs';
import { ExtendedPrintableData, PrintableData } from '../models/model.model';
import { toHttpParams } from './http-query-params';

@Injectable({ providedIn: 'root' })
export class PrintableDataService {
  private _http = inject(HttpClient);

  readonly update = new Subject<void>();
  beforeSendSvgEvent = new Subject<any>();

  getPrintableData(id: number): Observable<{ statusCode: number; data: PrintableData }> {
    return this._http.get<{ statusCode: number; data: PrintableData }>('/api/printable-data/' + id);
  }

  getPrintableDataList(query: PrintableDataQuery = {}): Observable<{ statusCode: number; data: EntityList<ExtendedPrintableData> }> {
    const route: Record<keyof PrintableDataQuery, string> = {
      brandName: 'brand-name',
      serieName: 'serie-name',
      modelName: 'model-name',
      exactSearch: 'exact-search',
      offset: 'offset',
      limit: 'limit',
      showParents: 'show-parents',
      modelIds: 'model-ids',
      type: 'type',
    };

    return this._http.get<{ statusCode: number; data: EntityList<ExtendedPrintableData> }>('/api/printable-data/list', {
      params: toHttpParams(query, route),
    });
  }

  addPrintableData(printableData: PrintableData): Observable<EmptyMutationResponse> {
    return this._http.post('/api/printable-data', printableData, { observe: 'response' }).pipe(
      map(toEmptyMutationResponse),
      tap(() => this.update.next()),
    );
  }

  deletePrintableData(printableDataId: number): Observable<EmptyMutationResponse> {
    return this._http.delete('/api/printable-data/' + printableDataId, { observe: 'response' }).pipe(
      map(toEmptyMutationResponse),
      tap(() => this.update.next()),
    );
  }
}

export type PrintableDataQuery = {
  brandName?: string;
  serieName?: string;
  modelName?: string;
  exactSearch?: boolean;
  offset?: number;
  limit?: number;
  showParents?: boolean;
  modelIds?: number[];
  type?: string;
};

type EmptyMutationResponse = { statusCode: number };

const toEmptyMutationResponse = (response: HttpResponse<unknown>): EmptyMutationResponse => ({ statusCode: response.status });
